const bigInput = {
  color: {
    white: {
      outline:
        'bg-white  text-gray-900  ring-0 ring-inset ring-gray-300 focus:ring-2 focus:ring-primary-500 ',
    },
  },
  size: {
    xl: 'text-base font-bold leading-6 h-[72px]',
  },
  icon: {
    size: {
      xl: 'h-6 w-6',
    },
  },
}

const bigInputDark = {
  ...bigInput,
  placeholder: 'placeholder-gray-900',
}

export { bigInput, bigInputDark }
